import { Component } from "react"

/* Components */
import { Layout, Video } from "../../components"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { withRouter } from "../../helpers"

/* REST API */
import { get } from "../../api/Table"

/* SOCKET.IO */
import { io } from "socket.io-client"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Widgets */
import { Games, GameInformation } from "../../widgets/VipThreeBoxGame"
import { Dealer, Settings, Currency, Message, Control } from "../../widgets/Table"

/* Modal */
import Modal from "react-modal"






/* Page Multi Game */
class MultiGame extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            connection: "loading",
            data: null,
            page: "",
            gameID: 0,
            number: "",
        }

        this.socket = null
        this.timing = null
    }


    componentDidMount = () => {

        /* Start Load Data About Table */
        this.load()

        /* Start Listen Socket Events */
        this.socketEvents()

    }


    componentWillUnmount = () => {

        /* Remove Timing */
        if (this.timing) {
            clearTimeout(this.timing)
            this.timing = null
        }

        /* Remove Socket */
        if (this.socket) {
            this.socket.off("connect")
            this.socket.off("disconnect")
            this.socket.disconnect()
            this.socket.close()
            this.socket = null
        }

    }


    /* Load Table Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props.params

        /* Check Data */
        if (uid) {

            /* Refresh the page if necessary */
            if (reload) {
                this.setState({ status: "loading" })
            }

            /* START REST API */
            get({ uid }).then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.setState({ status: "ok", data })
                    this.connect(data)
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ status: "permission", data: null })
                }
                else if (response.status === 498) {
                    this.setState({ status: "key", data: null })
                }
                else {
                    this.setState({ status: "error", data: null })
                }
            }).catch(() => {
                this.setState({ status: "network", data: null })
            })
        }
        else {
            this.setState({ status: "error", data: null })
        }

    }

    /* Connect Socket */
    connect = (data) => {

        try {
            this.socket = io(data.backURL, { auth: { token: `${data.adminToken}`, type: "admin" } })
        }
        catch {
            this.setState({ connection: "disconnected" })
        }

    }

    /* Socket Events */
    socketEvents = () => {

        if (this.socket) {

            if (this.timing) {
                clearTimeout(this.timing)
                this.timing = null
            }

            if (this.socket.connected) {
                this.setState({ connection: "connected" })
            }

            this.socket.on("connect", () => {
                this.setState({ connection: "connected" })
            })

            this.socket.on("connect_error", () => {
                this.setState({ connection: "disconnected" })
            })

            this.socket.on("disconnect", () => {
                this.setState({ connection: "disconnected" })
            })

        }
        else {
            this.timing = setTimeout(() => {
                clearTimeout(this.timing)
                this.timing = null
                this.socketEvents()
            }, 2000)
        }

    }


    /* Get Menu */
    /* Get Menu */
    _getMenu = () => {

        /* Fields */
        const { admin } = this.props

        /* Only SuperAdmin can see Currencies and Settings */
        const isAdmin = admin && admin.isAdmin === 1

        /* Default Menu */
        const menu = [
            { key: "control", text: t("game.parameters"), image: <img src="/images/parameters.png" alt="Parameters" /> },
            { key: "message", text: t("game.writeMessage"), image: <img src="/images/chat.png" alt="Chat" /> },
            { key: "dealers", text: t("game.dealers"), image: <img src="/images/croupier.png" alt="Croupier" /> },
        ]

        /* SuperAdmin Tabs */
        if (isAdmin) {
            menu.push({ key: "currencies", text: t("game.currencies"), image: <img src="/images/dollar.png" alt="Dollar" /> })
            menu.push({ key: "settings", text: t("game.settings"), image: <img src="/images/setting.png" alt="Setting" /> })
        }

        return menu
    }

    /* Get Menu Data */
    getData = (page) => {

        /* Fields */
        const { postfix, params } = this.props
        const { uid } = params

        /* Draw Game Modal */
        if (page === "game") {

            /* Fields for game */
            const { number, gameID } = this.state

            return {
                title: `${t("game.gameNumber")}${number}`,
                content: <GameInformation postfix={postfix} closeWithUpdate={() => this.closeWithUpdate()} gameID={gameID} uid={uid} socket={this.socket} />,
            }
        }

        /* Get Modal key */
        const menu = this._getMenu()
        const index = menu.findIndex((e) => e.key === page)

        if (index > -1) {

            let content = null

            if (page === "message") {
                content = <Message uid={uid} socket={this.socket} />
            }

            if (page === "dealers") {
                content = <Dealer uid={uid} />
            }

            if (page === "currencies") {
                content = <Currency uid={uid} />
            }

            if (page === "settings") {
                content = <Settings uid={uid} />
            }

            if (page === "control") {
                content = <Control uid={uid} socket={this.socket} />
            }

            return {
                title: menu[index].text,
                content,
            }
        }

        return {
            title: "",
            content: null,
        }

    }


    /* Draw Connection State */
    _connection = () => {

        /* Fields */
        const { connection } = this.state

        /* Success */
        if (connection === "connected") {
            return (
                <div className="multipoker--game-header-connection-status connected">
                    <img src="/images/correct.png" alt="Correct" />
                    {t("game.connectionOk")}
                </div>
            )
        }

        /* Disconnect */
        if (connection === "disconnected") {
            return (
                <div className="multipoker--game-header-connection-status disconnected">
                    <img src="/images/cross.png" alt="Cross" />
                    {t("game.connectionFail")}
                </div>
            )
        }

        return (
            <div className="multipoker--game-header-connection-status">
                <LoadingOutlined />
                {t("game.connecting")}
            </div>
        )
    }


    /* Draw Menu */
    _menu = () => {
        return (
            <div className="multipoker--game-menu">

                {/* Draw Menu */}
                {this._getMenu().map((item, index) =>
                    <div onClick={() => this.setState({ page: item.key })} className="multipoker--game-menu-item" key={`${index}`}>
                        {item.image}
                        <span>{item.text}</span>
                    </div>
                )}

                <a target="_blank" href="https://zm.makao.in/" rel="noreferrer" className="multipoker--game-menu-item video">
                    <img src="/images/video-folder.png" alt="VideoFolder" />
                    <span>{t("game.videoArchive")}</span>
                </a>

            </div>
        )
    }

    /* Open Game Inner Action */
    openGame = (id, number) => {
        this.setState({ page: "game", gameID: id, number })
    }

    /* Close Modal Action */
    close = () => {
        this.setState({ page: "", gameID: 0, number: "" })
    }

    /* Close with Update */
    closeWithUpdate = () => {

        /* Check Games */
        if (this._games) {
            this._games.reloadGames()
        }

        /* Clear */
        this.setState({ page: "", gameID: 0, number: "" })
    }

    /* Draw Modal */
    _modal = () => {

        /* Fields */
        const { page } = this.state
        const data = this.getData(page)

        return (
            <Modal
                isOpen={page !== ""}
                onRequestClose={() => this.close()}
                className={`multipoker--modal ${page === "game" ? "multipoker--modal-game" : ""}`}
                overlayClassName="multipoker--overlay"
                closeTimeoutMS={200}
            >

                {/* Modal Header */}
                <div className="multipoker--modal-header">
                    <h2>{data.title}</h2>
                    <div onClick={() => this.close()} className="multipoker--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Modal Content */}
                {data.content}

            </Modal>
        )
    }


    render = () => {

        /* Fields */
        const { status, data } = this.state
        const { postfix } = this.props

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                {/* Header */}
                <div className="multipoker--game-header">
                    <h1>{data.name}</h1>
                    <div className="multipoker--game-header-connection">
                        <p>{data.slug}</p>
                        {this._connection()}
                    </div>
                </div>

                {/* Draw Menu */}
                {this._menu()}

                <Games ref={(ref) => this._games = ref} postfix={postfix} uid={data.uid} openGame={(id, number) => this.openGame(id, number)} />

                {/* Draw Modal */}
                {this._modal()}

                {/* Draw Video */}
                <Video room={data.room} serviceURL={data.serviceURL} />

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    admin: state.admin,
})

export default connect(mapStateToProps)(withRouter(MultiGame))